// extracted by mini-css-extract-plugin
export default {"container":"jK-z","topReviewHeading":"kK-z","criticalReview":"lK-z","favorableReview":"mK-z","vsSeparator":"nK-z"};